export interface TeamStaffTO {
  clinicianId: number;
  firstName: string;
  lastName: string;
  accessToken: string;
  patientOnList: number;
  roles: string[] | null;
}

export const toTeamStaffTO = (staffRawData: any): TeamStaffTO => ({
  clinicianId: staffRawData.clinician_id,
  firstName: staffRawData.first_name,
  lastName: staffRawData.last_name,
  accessToken: staffRawData.access_token,
  patientOnList: staffRawData.patientOnList,
  roles: staffRawData.roles,
});
